import _ from 'underscore';
import { createSelector } from 'reselect';
import { configMomentFr } from '../../config';

import { getItemsSelector as getOrgasSelector } from '../../commons/reduxModules/APIOrgas';

import {
    REQUEST_POST_SUPPORT,
    REQUEST_POST_SUPPORT_SUCCESS,
    REQUEST_POST_SUPPORT_ERROR,
} from '../../commons/reduxModules/APISupport';

configMomentFr();

export const INIT_CONTACT_SUPPORT_APP = 'INIT_CONTACT_SUPPORT_APP';
export const INIT_CONTACT_SUPPORT_SUCCESS = 'INIT_CONTACT_SUPPORT_SUCCESS';

export const SET_ORGA = 'SET_ORGA';

export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

export const SET_CURRENT_EVENT_TYPE = 'SET_CURRENT_EVENT_TYPE';
export const SET_CURRENT_PHONE = 'SET_CURRENT_PHONE';
export const SET_CURRENT_EMAIL = 'SET_CURRENT_EMAIL';
export const SET_CURRENT_MESSAGE = 'SET_CURRENT_MESSAGE';
export const SET_CURRENT_NAME = 'SET_CURRENT_NAME';
export const SET_CURRENT_QUESTION_TYPE = 'SET_CURRENT_QUESTION_TYPE';

export const POST_SUPPORT_THREAD = 'POST_SUPPORT_THREAD';
export const POST_SALESMAN_THREAD = 'POST_SALESMAN_THREAD';
export const REQUEST_POST_CONVERSATION = 'REQUEST_POST_CONVERSATION';

export const SHOW_QUESTION_ERRORS = 'SHOW_QUESTION_ERRORS';
export const HIDE_QUESTION_ERRORS = 'HIDE_QUESTION_ERRORS';

export const APP_STATUS = {
    INITIALIZING: 0,
    INITIALIZED: 1,
};

function AppFormContact(
    state = {
        status: APP_STATUS.INITIALIZING,
        orgaId: null,
        currentEventType: '',
        currentPhone: '',
        currentName: '',
        currentEmail: '',
        currentMessage: '',
        currentQuestionType: '',
        questionErrorsDisplayed: false,
        isSending: false,
    },
    action,
) {
    switch (action.type) {
        case INIT_CONTACT_SUPPORT_SUCCESS:
            return {
                ...state,
                status: APP_STATUS.INITIALIZED,
            };
        case SET_ORGA:
            return {
                ...state,
                orgaId: action.payload.orgaId,
            };
        case SET_CURRENT_EVENT_TYPE:
            return {
                ...state,
                currentEventType: action.payload.eventType,
            };
        case SET_CURRENT_PHONE:
            return {
                ...state,
                currentPhone: action.payload.phone,
            };
        case SET_CURRENT_EMAIL:
            return {
                ...state,
                currentEmail: action.payload.email,
            };
        case SET_CURRENT_MESSAGE:
            return {
                ...state,
                currentMessage: action.payload.message,
            };
        case SET_CURRENT_NAME:
            return {
                ...state,
                currentName: action.payload.name,
            };
        case SET_CURRENT_QUESTION_TYPE:
            return {
                ...state,
                currentQuestionType: action.payload.questionType,
            };
        case SHOW_QUESTION_ERRORS:
            return {
                ...state,
                questionErrorsDisplayed: true,
            };
        case HIDE_QUESTION_ERRORS:
            return {
                ...state,
                questionErrorsDisplayed: false,
            };
        case REQUEST_POST_SUPPORT:
            return {
                ...state,
                isSending: true,
            };
        case REQUEST_POST_SUPPORT_ERROR:
        case REQUEST_POST_SUPPORT_SUCCESS:
            return {
                ...state,
                isSending: false,
            };
        default:
            break;
    }
    return state;
}

export default AppFormContact;

/*
    ActionCreators
 */

export function initContactSupportApp(orgaId) {
    return {
        type: INIT_CONTACT_SUPPORT_APP,
        payload: {
            orgaId,
        },
    };
}

export function initContactSupportSuccess() {
    return {
        type: INIT_CONTACT_SUPPORT_SUCCESS,
    };
}

export function openModal({ message } = {}) {
    return {
        type: OPEN_MODAL,
        payload: {
            message,
        },
    };
}

export function closeModal() {
    return {
        type: CLOSE_MODAL,
    };
}

export function setOrgaId(orgaId) {
    return {
        type: SET_ORGA,
        payload: {
            orgaId,
        },
    };
}

export function setCurrentEventType(eventType) {
    return {
        type: SET_CURRENT_EVENT_TYPE,
        payload: {
            eventType: eventType.name,
        },
    };
}

export function setCurrentPhone(phone) {
    return {
        type: SET_CURRENT_PHONE,
        payload: {
            phone,
        },
    };
}

export function setCurrentEmail(email) {
    return {
        type: SET_CURRENT_EMAIL,
        payload: {
            email,
        },
    };
}

export function setCurrentMessage(message) {
    return {
        type: SET_CURRENT_MESSAGE,
        payload: {
            message,
        },
    };
}

export function setCurrentName(name) {
    return {
        type: SET_CURRENT_NAME,
        payload: {
            name,
        },
    };
}

export function setCurrentQuestionType(questionType) {
    return {
        type: SET_CURRENT_QUESTION_TYPE,
        payload: {
            questionType: questionType.label,
        },
    };
}

export function postSupportThread() {
    return {
        type: POST_SUPPORT_THREAD,
    };
}

export function postSalesmanThread() {
    return {
        type: POST_SALESMAN_THREAD,
    };
}

export function showQuestionErrors() {
    return {
        type: SHOW_QUESTION_ERRORS,
    };
}

export function hideQuestionErrors() {
    return {
        type: HIDE_QUESTION_ERRORS,
    };
}

/*
    Selectors
 */

export function getOrgaIdSelector(state) {
    return state.AppFormContact.orgaId;
}

export const getCurrentOrgaSelector = createSelector(
    [getOrgasSelector, getOrgaIdSelector],
    (orgas, orgaId) => _.find(orgas, { id: orgaId }),
);

export function isInitiatedSelector(state) {
    return state.AppFormContact.status === APP_STATUS.INITIALIZED;
}

export function getCurrentEventTypeSelector(state) {
    return state.AppFormContact.currentEventType;
}

export function getCurrentNameSelector(state) {
    return state.AppFormContact.currentName;
}

export function getCurrentPhoneSelector(state) {
    return state.AppFormContact.currentPhone;
}

export function getCurrentEmailSelector(state) {
    return state.AppFormContact.currentEmail;
}

export function getCurrentMessageSelector(state) {
    return state.AppFormContact.currentMessage;
}

export function getCurrentQuestionTypeSelector(state) {
    return state.AppFormContact.currentQuestionType;
}

export function isQuestionErrorsDisplayedSelector(state) {
    return state.AppFormContact.questionErrorsDisplayed;
}

export function isSendingSelector(state) {
    return state.AppFormContact.isSending;
}
